angular.module("leanlaw").controller("RateGroupModalController", ["$scope", "close", "details", "rateGroups", "selectedRateGroup", "matter", "alerts", "leanLawApi", "me", function ($scope, close, details, rateGroups, selectedRateGroup, matter, alerts, leanLawApi, me) {
  $scope.rateGroups = rateGroups;
  $scope.details = details;
  $scope.selectedRateGroup = selectedRateGroup;
  $scope.updateRateGroupForClient = false;
  $scope.updateEntriesForRateGroup = true;
  $scope.matter = matter;
  $scope.me = me;

  // Watch for changes to selectedRateGroup and uncheck updateRateGroupForClient if rate group is cleared
  $scope.$watch('selectedRateGroup', function (newValue) {
    if (!newValue) {
      $scope.updateRateGroupForClient = false;
    }
  });
  $scope.confirm = function () {
    $scope.saving = true;
    leanLawApi.updateMatter({
      id: $scope.matter.id,
      body: {
        rateGroup: {
          rateGroupId: $scope.selectedRateGroup?.rateGroupId
        },
        updateRateGroupForClient: $scope.updateRateGroupForClient,
        rateOptions: {
          updateEntries: $scope.updateEntriesForRateGroup
        }
      }
    }).then(matter => {
      if ($scope.selectedRateGroup) {
        const message = $scope.updateRateGroupForClient ? `The rate group '${$scope.selectedRateGroup.name}' has been applied to all matters for this client.` : `The rates for this matter are now managed through the rate group '${$scope.selectedRateGroup.name}'`;
        alerts.success(message);
      } else {
        alerts.success("The rate group was removed from the matter it is now using custom rates.");
      }
      close(matter);
    }).catch(err => {
      alerts.error(err);
    }).finally(() => {
      $scope.saving = false;
    });
  };
  $scope.reject = function () {
    close(false);
  };
}]);